<template>
  <delivered_mr-component>
    <b-row class="mt-2 mb-2">          

        <b-col md="4">
            <b-form-group >
                <b-form-textarea v-model.trim="searching" style="height:100px" placeholder="Type to Search : 1023,Test" @input="checklenght(searching)">
                </b-form-textarea>
            </b-form-group>
        </b-col>

        <b-col md="5">
            <b-form-group  label="Select Vehicle NO." label-cols="4" class="mb-4">
                <v-select v-model="selected_vehicleno" @input="selectsearchvehicle(selected_vehicleno)" :options="vehiclenumber" placeholder="-- Select Vehicle NO --"></v-select>
            </b-form-group>
        </b-col>
        <b-col md="4">
            <b-form-group label="From Date:"  :label-cols="3" >
                <v-date-picker mode='single' 
                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
               </v-date-picker>
            </b-form-group>
        </b-col>

        <b-col md="4">
            <b-form-group label="To Date:"  :label-cols="3" >
                <v-date-picker mode='single' 
                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                </v-date-picker>
            </b-form-group>
        </b-col>
        <b-col md="3">
            <!-- :disabled="searching.length == 0 && selected_vehicleno==0" -->
            <b-button  @click="deliveredListing(pageNum)"  size="md" variant="primary">Search</b-button>
            &nbsp;
            <b-button  @click="clearSearch()" size="md" variant="danger">Clear</b-button>&nbsp;

            <a :href="loadurl" target="_blank" v-if="totalRows>0">
                <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
            </a>
        </b-col>
        
        <!-- <b-col md="2">
            <a :href="loadurl" target="_blank">
            <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
            </a>
            
        </b-col> -->
    </b-row> 

    <b-row>
        <b-col sm="12" class="text-right">
            <p> <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
        </b-col> 

        <b-col sm="12">
            <b-table show-empty responsive  :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy"> 
                
                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>  
                <template slot="invoicevalue" slot-scope="row">
                        <span>&#8377; {{row.item.invoicevalue}}</span>
                </template>
                <template slot="awbphysicalweight" slot-scope="row">
                <span> {{row.item.awbphysicalweight}} {{row.item.unit}}</span>
                </template>
                <template slot="parentawb" slot-scope="row">
                    <!-- <span>{{row.item.parentawb}}</span> -->
                    <button v-b-tooltip.hover title="View Details" @click="viewDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                        <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
                    
                    </button>
                        
                    </template>
                <template slot="mpscount" slot-scope="row">
                    <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                        <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
                    
                    </button>
                    
                </template>
                <template slot="vehicle_no" slot-scope="row">
                    <span> {{row.item.vehicleno_prefix}} {{row.item.vehicle_no}}</span>
                    
                </template>
                <!-- <template slot="sourceaddress" slot-scope="row">
                <span v-if="row.item.sourceaddress !=null" :title="row.item.sourceaddress"> {{row.item.sourceaddress.substring(0,30)+".."}}</span>
                    
                </template> -->
                <!--  <template slot="destinationaddress" slot-scope="row">
                    <span v-if="row.item.destinationaddress !=null" :title="row.item.destinationaddress"> {{row.item.destinationaddress.substring(0,30)+".."}}</span>
                    
                </template> -->
                <template slot="bookingdonedate" slot-scope="row">
                    <span v-if="row.item.bookingdonedate !=null" > {{row.item.bookingdonedate}}</span>
                    <span v-else > - </span>

                    
                </template>
            </b-table> 
        </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" class="text-right">
        <!-- <br> -->
             <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
            </b-col>
       <b-col md="12" class="my-1" >
        <!-- <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination> -->
      <paginate 
        :page-count="noofpages"
        :page-range="10"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :container-class="'pagination'"
        :page-class="'page-item'">
      </paginate>
      </b-col>   
    </b-row> 

    <b-modal
         size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
        <template slot="default" slot-scope="{ hide }">
        <b-row>
        <b-col sm="12" class="text-right">
                <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                </b-col>   
                <div style="float: left;">
                    <!-- v-if="this.mpstotalRows > 0" -->
                    <span class="badge ml-2" 
                    style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
                    <span class="badge ml-2" 
                    style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
                </div>
        <b-col sm="12"> 
            <!-- <b-col sm="12"> -->
        <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusymps" >
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
            <template slot="shippingid" slot-scope="row">
                <span>{{row.item.shippingid}}</span>
                <br>
                <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                &nbsp;
                <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px;cursor: pointer;">SB</span>
            </template>
            <template slot="mpsvalue" slot-scope="row">
                    <span>&#8377; {{row.item.mpsvalue}} </span>
                </template> 
            <template slot="physicalweight" slot-scope="row">
                    <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                </template>
                <template slot="physicalweight" slot-scope="row">
                    <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                </template>
                <template slot="breadth" slot-scope="row">
                    <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                </template>
                <template slot="length" slot-scope="row">
                    <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                </template>
                <template slot="height" slot-scope="row">
                    <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                </template>
                
        </b-table> 
        <!-- </b-col> -->
        </b-col>
        </b-row> 
        <b-row>
        <b-col md="6" class="my-1" v-if="mpstotalRows>10">
            <b-pagination
                v-model="mpscurrentPage"
                :total-rows="mpstotalRows"
                :per-page="mpsperPage"
                class="my-0"
                ></b-pagination>
        </b-col> 
        </b-row>
            <div class="col-md-12 pull-right"> 
                    <div slot="footer" class="text-right">
                    
                    <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                    </div>
                </div>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
            <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
            Cancel
            </b-button>
        </template>
    </b-modal>

    <b-modal 
        size="xl" title="AWB Details" v-model="awbdetailsmodal" @ok="awbdetailsmodal = false" hide-footer>
        <template slot="default" slot-scope="{ hide }">
            <b-row class="col-md-12" > 
                    <div class="col-md-3">
                    <span><b>Vehicle Id :</b></span>&nbsp;
                    <span>{{detailsitem.vehicle_id}}</span>
                    </div>
                    <div class="col-md-3">
                    <span><b>Parent Awb :</b></span>&nbsp;
                    <span>{{detailsitem.parentawb}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Category :</b></span>&nbsp;
                    <span>{{detailsitem.category}}</span>
                    
                    </div>
                    
                    <div class="col-md-3">
                    <span><b>Delivery Status :</b></span>&nbsp;
                    <span>{{detailsitem.deliverystatus}} </span>
                    
                    </div>
            </b-row>
            <br>
            <b-row class="col-md-12" > 
                <div class="col-md-3">
                    <span><b>Load ID :</b></span>&nbsp;
                    <span>{{detailsitem.invoiceno}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Invoice Date :</b></span>&nbsp;
                    <span>{{detailsitem.invoicedate}} </span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Invoice Value :</b></span>&nbsp;
                    <span>{{detailsitem.invoicevalue}}</span>
                    </div>
                    <div class="col-md-3">
                    <span><b>Pick Up Date:</b></span>&nbsp;
                    <span>{{detailsitem.pickupdatetime}}</span>
                    
                    </div>
                
            </b-row>
            <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Seller Name :</b></span>&nbsp;
                    <span>{{detailsitem.sellername}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b>Registor No :</b></span>&nbsp;
                    <span>{{detailsitem.sellergstregnumber}} </span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b> Weight :</b></span>&nbsp;
                    <span>{{detailsitem.valweight}} {{detailsitem.unit}}</span>
                    
                    </div>
                
                
                
                    
                    <div class="col-md-3">
                    <span><b>Risk :</b></span>&nbsp;
                    <span>{{detailsitem.risksurcharge}}</span>
                    
                    </div>
                
                
                
            </b-row>
            <br>
            <b-row class="col-md-12" >
                <div class="col-md-3">
                    <span><b>Seller Address :</b></span>&nbsp;
                    <span>{{detailsitem.selleraddress}}</span>
                    
                    </div>
                <div class="col-md-3">
                    <span><b>Seller State :</b></span>&nbsp;
                    <span>{{detailsitem.supplysellerstateplace}}</span>
            </div> 
                    
                    <div class="col-md-3">
                    <span><b>Seller Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.sellerpincode}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Route Mode :</b></span>&nbsp;
                    <span>{{detailsitem.routemode}}</span>
                    
                    </div>
            
            
            </b-row>
                <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Source Company :</b></span>&nbsp;
                    <span>{{detailsitem.sourcecompanyname}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b> Source Mailid :</b></span>&nbsp;
                    <span>{{detailsitem.sourceemailid}} </span>
                    
                    </div>
                
                <div class="col-md-3">
                    <span><b>Source Mobile No :</b></span>&nbsp;
                    <span>{{detailsitem.sourcemobileno}}</span>
                    
                    </div>
                
                    
                    <div class="col-md-3">
                    <span><b>Source Type :</b></span>&nbsp;
                    <span>{{detailsitem.sourcetype}}</span>
                    
                    </div>
                
            </b-row>
                <br>
            <b-row class="col-md-12" >
            
            <div class="col-md-3">
                    <span><b> Source Address :</b></span>&nbsp;
                    <span>{{detailsitem.sourceaddress}} </span>
                    
                    </div>
                    
                <div class="col-md-3">
                    <span><b>Source City :</b></span>&nbsp;
                    <span>{{detailsitem.sourcecity}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Source State :</b></span>&nbsp;
                    <span>{{detailsitem.sourcestate}}</span>
            </div> 
                    
                    <div class="col-md-3">
                    <span><b>Source Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.sourcepincode}}</span>
                    
                    </div>
                
            </b-row>
                    <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Destination Company :</b></span>&nbsp;
                    <span>{{detailsitem.destinationcompanyname}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b>Mail Id :</b></span>&nbsp;
                    <span>{{detailsitem.destinationemailid}} </span>
                    
                    </div>
                    
                <div class="col-md-3">
                    <span><b>Destination Mobile No :</b></span>&nbsp;
                    <span>{{detailsitem.destinationmobileno}}</span>
                    
                    </div>
                
                    
                    <div class="col-md-3">
                    <span><b>Destination Poc Name :</b></span>&nbsp;
                    <span>{{detailsitem.destinationspocpersonname}}</span>
                    
                    </div>
                
            </b-row>
                <br>
            <b-row class="col-md-12" >
            
            <div class="col-md-3">
                    <span><b> Destination Address :</b></span>&nbsp;
                    <span>{{detailsitem.destinationaddress}} </span>
                    
                    </div>
                
                <div class="col-md-3">
                    <span><b>Destination City :</b></span>&nbsp;
                    <span>{{detailsitem.destinationcity}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Destination State :</b></span>&nbsp;
                    <span>{{detailsitem.destinationstate}}</span>
            </div> 
                    
                    <div class="col-md-3">
                    <span><b>Destination Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.destinationpincode}}</span>
                    
                    </div>
                    <div class="col-md-12 pull-right"> 
                    <div slot="footer" class="text-right">
                    
                    <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                    </div>
                </div>
                
            </b-row>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
            <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
            Cancel
            </b-button>
        </template>
    </b-modal>

    <b-modal 
        size="md" id="defective_image_modal" title="Defective Image" hide-footer>
        <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
            No Record Found
        </div>
        <div v-else class="text-center">
            <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
        </div>
    </b-modal>

  </delivered_mr-component>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
    data: function() {
        return {
            result:[],
            items:[],
            isBusy: false,
            
            fields: [
            
                { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
                { key: 'vehicle_name', label: 'Vehicle Name', sortable: true, sortDirection: 'desc' },
                { key: 'vehicle_no', label: 'Vehicle Number.', sortable: true, sortDirection: 'desc' },
                { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'warehouseid', label:'WareHouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'invoicevalue', label: 'Invoice Value', sortable: true,class:'invoicevalue'},
                { key: 'awbphysicalweight', label: 'Weight', sortable: true,class:'physicalweight'},
                { key: 'mpscount', label: 'MPS Count', sortable: true},
                { key: 'shipmentstatus', label: 'Shipment Status', sortable: true },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
                // { key: 'sourceaddress', label: 'Source Address', sortable: true},
                { key: 'custvendorname', label: 'WareHouse Name', sortable: true},
                { key: 'destinationaddress', label: 'Destination Address', sortable: true},
                { key: 'bookingdonedate', label: 'BookingDone Date', sortable: true},
                { key: 'ofddate', label: ' OFD Date', sortable: true},
                { key: 'lastmodifieddate', label: 'Delivery Date', sortable: true},


                            
                // { key: 'createddate', label: 'Date', sortable: true },
                
                // { key: 'actions', label: 'Actions' },
            ],
                mpsfields:[
                // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
                
                { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
                { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
                { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
                { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
                
                { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
                { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                
            ],
            mpsitems:[],
            isBusymps :false,
            productdetailsModal:false,
            awbdetailsmodal:false,
            detailsitem:'',
            outlined: true,
            totalRows: 0,
            currentPage: 1,
            perPage:  60,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            mpscurrentPage:1,
            mpsperPage:10,
            searching:[],
            searchvaluesarr:[],
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            loadurl:'',
            selected_user_details :'',
            vehicleitems : [],
            vehiclenumber : [],
            selected_vehicleno : '',
            selectDateFrom: new Date(),
            selectDateTo:new Date(),
        }
    },
    created: function() {
        this.vehicleListing();
        this.deliveredListing(this.pageNum);
    },
    props:["route_id"],

    mounted () {
    },
    computed: {
        sortOptions() {
        // Create an options list from our fields
        return this.fields
            .filter(f => f.sortable)
            .map(f => {
            return { text: f.label, value: f.key }
            })
        }
    },
    methods: {
        checklenght(value){
        console.log("value",value)
        if (value.length==0) {
          this.searching=[]
          this.totalRows=0
          this.searchvaluesarr=[]
          this.deliveredListing(this.pageNum)
        }
      },
        downlaodloadurl(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

                var searchvehicleid = [];
                searchvehicleid = this.selected_vehicleno.split('-');
                console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvv",searchvehicleid[1])
                var selectedvehicleno = searchvehicleid[1];

            if (this.searchvaluesarr.length>0) {
            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`Delivered`+`&&`+`payloadArr=`+this.searchvaluesarr+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')+`&&fromdate=`+fromdate+`&&todate=`+formatdateto+`&&vehicle_id=`+(selectedvehicleno==undefined?'':selectedvehicleno)


            // http://localhost:8081/api_ftl/getCSVForAllocatedLoadsListing?for_status=Delivered&fromdate=2023-06-21&todate=2023-06-27&is_asn=NO&sysusermasterid=12&usertype=1&vehicle_id=513

            console.log("this.loadurl",this.loadurl)
            } else {
            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`Delivered`+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')+`&&fromdate=`+fromdate+`&&todate=`+formatdateto+`&&vehicle_id=`+(selectedvehicleno==undefined?'':selectedvehicleno)

            console.log("this.loadurl",this.loadurl)
            }
        },

        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },

        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            console.log("pageNum",this.listingpageno)
            this.deliveredListing(pageNum);
        },

        viewProduct:function(value){
            this.mpscurrentPage=1;
            this.productdetailsModal=true;
            this.isBusymps = true;
        console.log("value",value);
    let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
        
        
        
        let obj = {
            parentawb: value.parentawb,
        }
        this.$http
            .post(
                `${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
            .then(result => {
                console.log(result.body);
                this.isBusymps = false;
                if(result.body.returnmsg === "successful"){
                
                this.mpsitems  = result.body.returnvalue;
                // console.log("HHHHH",this.mpsitems);
                    this.mpstotalRows = result.body.returnvalue.length
                    // console.log("RRRRR",this.mpsitems);
                
                }else {
                this.mpsitems  = [];
                this.mpstotalRows = 0
                }
            }).catch(ex => {
                console.log('error', ex)
            })
            
        },

        modalCancel:function(){
            this.productdetailsModal=false;
        },

        viewDetails:function(value){
            console.log("value",value);
            this.awbdetailsmodal=true;
            this.detailsitem=value;
        },

        detailsCancel:function(){
            this.awbdetailsmodal=false;
        },

        deliveredListing:function(pageNo){
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

            if (this.searching.length != 0 ) {
                var searchvalues=[];
                this.searchvaluesarr=[];
                //  searchvalues = this.searching.split(',')
                searchvalues = this.searching.split(/[','|' '|'\n']/)
                for (var i = 0; i < searchvalues.length; i++) {
                    this.searchvaluesarr.push(`${searchvalues[i]}`)
                }
                console.log("YYY",this.searchvaluesarr)
            }
            if (this.selected_vehicleno.length != 0 ) {
                var searchvehicleid = [];
                searchvehicleid = this.selected_vehicleno.split('-');
                console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvv",searchvehicleid[1])
                var selectedvehicleno = searchvehicleid[1];
            }
           
            this.isBusy = true;
            let pincode=JSON.stringify(userInfo.pickuplocationpincode);
            let obj = {
                for_status: "Delivered",
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,
                payloadArr:this.searchvaluesarr.length>0?this.searchvaluesarr:'',
                page_no:`${pageNo}`,
                is_asn: this.route_id == 'normal' ? 'NO': 'YES',
                fromdate : fromdate,
                todate : formatdateto,
                vehicle_id : selectedvehicleno,
            }
            
            console.log("asn",obj)

            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                document.getElementById("overlay").style.display = "none";
                    this.isBusy = false; 
                    return false;       
            }
            
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllocatedLoadsListing`,obj)
            .then(result => {
                console.log(result.body);
                this.isBusy = false;
                if(result.body.returnmsg === "successful"){
                    console.log("result.body.returnvalue",result.body.returnvalue);
                    
                this.items  = result.body.returnvalue;
                console.log("HHHHH",this.items);
                this.totalRows = result.body.totalcount;
                this.noofpages=parseInt(this.totalRows)/60;
                console.log("this.noofpages",this.noofpages)
                this.noofpages=Math.ceil( this.noofpages);
                console.log("YYYYYY",this.noofpages)
                
                
                }else{
                    this.items  = [];
                this.totalRows = 0
                }
            }).catch(ex => {
                console.log('error', ex)
            })
        },

        searchInLoadManagement(){
        
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
        var searchvalues=[];
        this.searchvaluesarr=[];
        //  searchvalues = this.searching.split(',')
        searchvalues = this.searching.split(/[','|' '|'\n']/)
        for (var i = 0; i < searchvalues.length; i++) {
            this.searchvaluesarr.push(`${searchvalues[i]}`)
        }
        console.log("YYY",this.searchvaluesarr)
        // this.deliveredListing(this.pageNum)
        },

        clearSearch(){
        this.searching=[];
        this.selected_vehicleno = "";
        this.searchvaluesarr=[];
        this.selectDateFrom =  new Date();
        this.selectDateTo = new Date();
        this.deliveredListing(this.pageNum)
        },

        Viewimagedetails : function (data){
                this.selected_user_details=data;
                console.log("rrrrrrrrrrr",this.selected_user_details);
        },

        vehicleListing(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj = { }
            console.log("obj",obj)

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDeliveredVehicleListing`,obj)
                .then(result => {
                console.log("result",result)
                    if(result.body.returnmsg === "Successful"){
                    this.vehicleitems  = result.body.returnvalue;
                    console.log("vehicleitems",this.vehicleitems)
                    for (let i = 0; i < this.vehicleitems.length; i++) {

                        var vehicle_idDetails =  this.vehicleitems[i].vehicle_no + "-" +  this.vehicleitems[i].vehicle_id;
                    this.vehiclenumber.push(vehicle_idDetails)
                    }
                    
                    }else{
                    this.vehicleitems  = [];
                    }
                }).catch(ex => {
                console.log('error', ex)
                })
        },

        selectsearchvehicle(value_vehicle) {
            if(value_vehicle==null){
            this.selected_vehicleno="";
            this.searchvaluesarr=[];
            this.deliveredListing(this.pageNum);
            }
            console.log("value_vehicle : ",value_vehicle);
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
  }
};
</script>
<style>
.invoicevalue{
  width: 80px;
}
.physicalweight{
  width: 80px;
}
  
</style>
